// import React, { useEffect } from 'react';
// import { useLocation } from 'react-router-dom';

// import SamsaMandate from '../HomePage/SamsaMandate';
// import AboutBanner from './AboutBanner';
// import VisionMission from './VisionMission';
// import GoverningStructure from './GoverningStructure';
// import ManagementTeam from './ManagementTeam';
// import CorporateSocialInvestment from './CorporateSocialInvestment';
// import SocialMapping from './SocialMapping';
// import smpageBanner from './../../assets/images/samsa-banner-mb.png';
// import pageBanner from './../../assets/images/Home.png';

// function AboutPage() {
//   const location = useLocation();

//   useEffect(() => {
//     const queryParams = new URLSearchParams(location.search);
//     const section = queryParams.get('section');

//     if (section) {
//       const el = document.getElementById(section);

//       if (el) {
//         const header = document.querySelector('header');
//         const headerHeight = header ? header.offsetHeight : 0;

//         setTimeout(() => {
//           const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
//           window.scrollTo({ top, behavior: 'smooth' });
//         }, 300);
//       }
//     } else {
//       setTimeout(() => {
//         window.scrollTo({ top: 0, behavior: 'smooth' });
//       }, 100);
//     }
//   }, [location.search]);

//   return (
//     <>
//       <AboutBanner />

//       <section className="SamsaMandate position-relative px-4 bigarrow" id='SamsaMandate'>
//         <div className="container max-1330">
//           <div className="row g-3 g-sm-4 g-md-5">
//             <div className='col-lg-auto'>
//               <div className='samsa-img position-relative'>
//                 <picture>
//                   <source media="(max-width:757px)" srcSet={smpageBanner} />
//                   <img src={pageBanner} alt="SAMSA Banner" className='img-fluid mt-3' />
//                 </picture>
//               </div>
//             </div>

//             <div className='col-lg'>
//               <h1 className="section-title mb-0">SAMSA Mandate</h1>


//               <p className="mb-3">
//                 T​​he South African Maritime Safety Authority (SAMSA) was established on the 1st April 1998 under the SAMSA Act 5 of 1998. <br /><br />
//                 The objectives of the Authority are- <br />
//                 To ensure safety of life and property at sea;

//                 To prevent and combat pollution from ships in the marine environment; and

//                 To promote the Republic's maritime interests.

//                 SAMSA has also been charged with the responsibility of executing the following:

//                 Administration of the Merchant shipping (National Small Vessel Safety) Regulation, 2007, as amended (the Regulations).

//                 The Regulations extends SAMSA's Core mandate to include inland waterways (only waterways accessible to the public) within the Republic. That is to ensure boating safety on our waters.

//                 Implementing and executing the Long-Range Identification and Tracking (LRIT) of vessels along the South African coastline.

//                 The Long-Range vessels monitoring system assist in securing South Africa's coastal waters in the midst of the rising lawlessness at sea, with particular reference to the worrying scourge of pirate attacks along the east coast of Africa.
//               </p>

//             </div>
//           </div>
//         </div>
//       </section>

//       <section className='p-0' id="vision-mission">
//         <VisionMission />
//       </section>
//       <section className='p-0' id="governing-structure">
//         <GoverningStructure />
//       </section>
//       <section className='p-0' id="management-team">
//         <ManagementTeam />
//       </section>
//       <section className='p-0' id="corporate-social-investments">
//         <CorporateSocialInvestment />
//       </section>
//       <section className='p-0' id="social-mapping">
//         <SocialMapping />
//       </section>

//     </>
//   );
// }

// export default AboutPage;


import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import SamsaMandate from '../HomePage/SamsaMandate';
import AboutBanner from './AboutBanner';
import VisionMission from './VisionMission';
import GoverningStructure from './GoverningStructure';
import ManagementTeam from './ManagementTeam';
import CorporateSocialInvestment from './CorporateSocialInvestment';
import SocialMapping from './SocialMapping';
import smpageBanner from './../../assets/images/SAMSAHOME.jpg';
import pageBanner from './../../assets/images/About-B.png';
import CoreValuesRadial from "./../AboutPage/ManagementTeamTab/CoreValuesRadial";

function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const section = queryParams.get('section');

    if (section) {
      const el = document.getElementById(section);

      if (el) {
        const header = document.querySelector('header');
        const headerHeight = header ? header.offsetHeight : 0;

        setTimeout(() => {
          const top = el.getBoundingClientRect().top + window.scrollY - headerHeight;
          window.scrollTo({ top, behavior: 'smooth' });
        }, 300);
      }
    } else {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  }, [location.search]);

  return (
    <>
      <AboutBanner />

      <section className="SamsaMandate position-relative px-4 bigarrow" id='SamsaMandate'>
        <div className="container max-1330">
          <div className="row g-3 g-sm-4 g-md-5">
            <h1 className="section-title text-center">SAMSA Mandate</h1>
            <div className='col-lg-auto'>
              <div className='samsa-img position-relative'>
                <picture>
                  <source media="(max-width:757px)" srcSet={smpageBanner} />
                  <img src={pageBanner} alt="SAMSA Banner" className='img-fluid mt-3' />
                </picture>
              </div>
            </div>

            <div className='col-lg'>
              {/* <h1 className="section-title mb-0">SAMSA Mandate</h1> */}


              {/* <p className="mb-3">
                T​​he South African Maritime Safety Authority (SAMSA) was established on the 1st April 1998 under the SAMSA Act 5 of 1998. <br /><br />
                The objectives of the Authority are- <br />
                To ensure safety of life and property at sea;

                To prevent and combat pollution from ships in the marine environment; and

                To promote the Republic's maritime interests.

                SAMSA has also been charged with the responsibility of executing the following:

                Administration of the Merchant shipping (National Small Vessel Safety) Regulation, 2007, as amended (the Regulations).

                The Regulations extends SAMSA's Core mandate to include inland waterways (only waterways accessible to the public) within the Republic. That is to ensure boating safety on our waters.

                Implementing and executing the Long-Range Identification and Tracking (LRIT) of vessels along the South African coastline.

                The Long-Range vessels monitoring system assist in securing South Africa's coastal waters in the midst of the rising lawlessness at sea, with particular reference to the worrying scourge of pirate attacks along the east coast of Africa.
              </p> */}
              <div class="vertical-scrol" id="AboutUs-scrol">
                 <p className="mb-3"><br/>
                T​​he South African Maritime Safety Authority (SAMSA) was established on the 1st April 1998 under the SAMSA Act 5 of 1998.
                <br />The objectives of the Authority are- <br /><br />
                <ul class="green-star-Ab-ul">
                  <li>To ensure safety of life and property at sea;
                  </li>
                  <li>To prevent and combat pollution from ships in the marine environment; and
                  </li>
                  <li>To promote the Republic's maritime interests.
                  </li>
                </ul> </p>
                {/* SAMSA has also been charged with the responsibility of executing the following:<br /><br />
                <ul class="green-star-Ab-ul">
                  <li>Administration of the Merchant shipping (National Small Vessel Safety) Regulation, 2007, as amended (the Regulations). 
                  </li>
                  <li>The Regulations extends SAMSA's Core mandate to include inland waterways (only waterways accessible to the public) within the Republic. That is to ensure boating safety on our waters.
                  </li>
                  <li>Implementing and executing the Long-Range Identification and Tracking (LRIT) of vessels along the South African coastline. 
                  </li>
                  <li>The Long-Range vessels monitoring system assist in securing South Africa's coastal waters in the midst of the rising lawlessness at sea, with particular reference to the worrying scourge of pirate attacks along the east coast of Africa.​
                  </li>
                  </ul> */}
            

             
              </div>
             

              
            </div>
          </div>
        </div>
      </section>
      {/* <section className='p-0' id="Core-Values">
        <CoreValuesRadial/>
      </section> */}

      <section className='p-0' id="vision-mission">
        <VisionMission />
      </section>
      
      <section className='p-0' id="governing-structure">
        <GoverningStructure />
      </section>
      <section className='p-0' id="management-team">
        <ManagementTeam />
      </section>
      
      <section className='p-0' id="corporate-social-investments">
        <CorporateSocialInvestment />
      </section><br />
      {/* <section className='p-0' id="social-mapping">
        <SocialMapping />
      </section> */}

    </>
  );
}

export default AboutPage;
